<script>
    import { loginUser } from '/public/services/users/users.js';
    import CreateAccount from '/public/components/users/StuckCreateAccount.svelte';
    import globaldata from '/core/stores/siteData';
    import { fade,slide } from 'svelte/transition';
    import { Eye, EyeSlash, Envelope, CheckCircle } from "svelte-bootstrap-icons";
    import ThexaHero from '/shared/c/logo/ThexaHero.svelte';

    let ctx = 'login';

    let email = null;
    let password = null;

    let context = ctx;

    let showPassword = false; 
    let showEmail = false;
    let regEmail = false;
    let hasAusXeroFile = false;
    let loginError = false;

    function processLogin(e) {
        e.preventDefault();
        
        loginError = false;        

        loginUser(email, password).then(res =>  {
            
            if (res.success === true) {
                
                window.location = res.data.url;
            } else {

                loginError = true;
                return;
            }
        });
    }   

    function gotoGoogle() {
        window.location = '/socials/auth/google';
    }
    
    function gotoXero() {
        window.location = "https://login.xero.com/identity/connect/authorize?client_id="+$globaldata.xero.client_id+"&redirect_uri="+$globaldata.xero.redirect_uri+"&scope=openid%20profile%20email&response_type=code&state="+$globaldata.xero.state;
    }

    
</script>
<div class=''>    

    <ThexaHero/>

    <div class='row mb-3 justify-content-center g-2'>
        <div class='col-6 text-center'>
            <div 
                class='d-block'
                on:click={() => context = 'login'}
                on:keypress={() => context = 'login'}
                role='button'
                tabindex='0'
                class:border-bottom='{context == "login"}'
                class:border-4='{context == "login"}'
                class:border-success='{context == "login"}'
                class:text-faint='{context != "login"}'
            >
                <h4>                                        
                    Sign in
                </h4>
            </div>
        </div>
        <div class='col-6 text-center'>
            <div 
                class='d-block'
                on:click={() => context = 'signup'}
                on:keypress={() => context = 'signup'}
                role='button'
                tabindex='0'
                class:border-bottom='{context == "signup"}'
                class:border-4='{context == "signup"}'
                class:border-success='{context == "signup"}'
                class:text-faint='{context != "signup"}'
            >
                <h4>                   
                    Register
                </h4>
            </div>
        </div>
    </div>

    {#if context == 'login'}

        <section in:fade class='mt-4'>
            <div class='row justify-content-center'>
                <div class='col-sm-12'>  
                    <div 
                        class='card mb-2 js-button card-login border-primary border-2'
                        on:click={gotoXero}
                        on:keypress={gotoXero}
                        role='button'
                        tabindex='0'
                    >   
                        <div class='card-body'>
                            <div class='row'>
                                <div class='col-1 text-center'>
                                    <img src='/images/xero.png' class='img-fluid login-logo mx-auto' alt="Xero Accounting"/>
                                </div>
                                <div class='col-11'>
                                    <h5 class='m-0'>
                                        Sign in with Xero
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--
                    <div 
                        class='card mb-2 js-button card-login'
                        on:click={gotoGoogle}
                        on:keypress={gotoGoogle}
                        role='button'
                        tabindex='0'
                    >   
                        <div class='card-body'>
                            <div class='row'>
                                <div class='col-1 text-center'>
                                    <img 
                                        src='/images/google-logo.png' 
                                        class='img-fluid login-logo mx-auto' 
                                        alt='Google Sign in'
                                    /> 
                                </div>
                                <div class='col-11'>
                                    <h5 class='m-0'>
                                        Sign in with Google  
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    -->
                    <div 
                        class='card mb-2 js-button card-login'
                        on:click={() => showEmail = ! showEmail}
                        on:keypress={() => showEmail = ! showEmail}
                        role='button'
                        tabindex='0'
                        class:text-bg-primary='{showEmail === true}'
                    >   
                        <div class='card-body'>
                            <div class='row'>
                                <div class='col-1 text-center'>
                                    <h5 class='d-inline-block mx-auto m-0'>

                                        <Envelope/>

                                    </h5>
                                </div>
                                <div class='col-11'>
                                    <h5 class='m-0'>
                                        Sign in with Email   
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>                     
                    
                    {#if showEmail === true}

                        {#if loginError === true}

                            <section in:slide class='mt-5 mb-5'>
                                <div class='text-center text-danger'>
                                    Your email or password is incorrect
                                </div>                                
                            </section>

                        {/if}

                        <form on:submit={processLogin} class="form-horizontal mb-5" in:slide>
                            <div class="mb-3 form-floating">                                
                                <input 
                                    type="email" 
                                    id="email" 
                                    class="form-control" 
                                    required bind:value={email}                                                                         
                                />         
                                <label for="name" class=''>
                                    Email Address
                                </label>                       
                            </div>
                        
                            <div class='mb-5'>                                   
                                <div class="input-group">

                                    <div class='form-floating'>
                                
                                        {#if showPassword === false}
                            
                                            <input 
                                                type='password'
                                                id="password" 
                                                class="form-control" 
                                                required 
                                                bind:value={password}                                                 
                                            />
                            
                                        {:else}
                            
                                            <input 
                                                type='text'
                                                id="password" 
                                                class="form-control" 
                                                required 
                                                bind:value={password}                                                 
                                            />
                            
                                        {/if}    

                                        <label for="password" class=''>
                                            Password
                                        </label> 
                                        
                                    </div>
                                    
                                    <span class='input-group-text'>                                

                                        <span 
                                            class='js-button fas'                                    
                                            on:click={() => showPassword = ! showPassword}
                                            on:keypress={() => showPassword = ! showPassword}
                                            role='button'
                                            tabindex='0'
                                        >

                                            {#if showPassword === false}

                                                <Eye/>

                                            {:else}

                                                <EyeSlash/>

                                            {/if}

                                        </span>
                                    </span>
                        
                                </div>                                                        
                            </div>        
                            <div class="mb-3">
                                <div class='d-grid'>
                                    <button type="submit" class="btn btn-primary text-white btn-lg">
                                        
                                        Continue

                                    </button>
                                </div>
                            </div>             
                        </form>

                    {/if}

                    <p class='mb-3 mt-5 text-center'>
                        New to THEXA? 
                        <span
                            class='fw-bold'
                            on:click={() => context = "signup"}
                            on:keypress={() => context = "signup"}
                            role='button'
                            tabindex='0'
                        >
                            Register for an account
                        </span>
                    </p>                                                       

                    <p class='mb-3 text-center'>
                        <a href="/forgot-my-password" class=''>
                            Forgot your password?
                        </a> 
                    </p> 
                </div>
            </div>                
        </section>

    {/if}

    {#if context == 'signup'}

        <section class='mb-5' in:fade>
            <div class='row justify-content-center'>
                <div class='col-sm-12'>  
                    <div class='text-center rounded-2 p-3 mb-3'>
                        <div class='mb-2 text-primary'>
                            <label>
                                <input type="checkbox" class='text-primary' bind:checked={hasAusXeroFile} /> Do you have an Australian Xero file?
                            </label>                            
                        </div>

                        {#if hasAusXeroFile === false}

                            <div out:slide>
                                <small>
                                    To ensure quality training, THEXA is currently only available for Australian based Xero organisations.
                                </small>
                            </div>

                        {/if}

                    </div>
                    <section 
                        class='position-relative'                           
                    >

                        {#if hasAusXeroFile === false}

                            <div class='position-absolute w-100 h-100 register-cover'></div>

                        {/if}

                        <div 
                            class='card mb-2 js-button card-login border-primary border-2'
                            on:click={gotoXero}
                            on:keypress={gotoXero}
                            role='button'
                            tabindex='0'
                            class:opacity-25='{hasAusXeroFile === false}'
                        >   
                            <div class='card-body'>
                                <div class='row'>
                                    <div class='col-1 text-center'>
                                        <img src='/images/xero.png' class='img-fluid login-logo' alt="Xero Accounting"/>
                                    </div>
                                    <div class='col-11'>
                                        <h5 class='m-0'>
                                            Register with Xero
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--
                        <div 
                            class='card mb-2 js-button card-login'
                            on:click={gotoGoogle}
                            on:keypress={gotoGoogle}
                            role='button'
                            tabindex='0'
                            class:opacity-25='{hasAusXeroFile === false}'
                        >   
                            <div class='card-body'>
                                <div class='row'>
                                    <div class='col-1 text-center'>
                                        <img 
                                            src='/images/google-logo.png' 
                                            class='img-fluid login-logo' 
                                            alt='Google Sign in'
                                        /> 
                                    </div>
                                    <div class='col-11'>
                                        <h5 class='m-0'>
                                            Register with Google  
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </div>

                        -->

                        <div 
                            class='card mb-5 js-button card-login'
                            on:click={() => regEmail = ! regEmail}
                            on:keypress={() => regEmail = ! regEmail}
                            role='button'
                            tabindex='0'
                            class:text-bg-primary='{regEmail === true}'
                            class:opacity-25='{hasAusXeroFile === false}'
                        >   
                            <div class='card-body'>
                                <div class='row'>
                                    <div class='col-1 text-center'>
                                        <h5 class='d-inline-block mx-auto m-0'>

                                            <Envelope/>

                                        </h5>
                                    </div>
                                    <div class='col-11'>
                                        <h5 class='m-0'>
                                            Register with Email   
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </div>  

                        {#if regEmail === true}

                            <section in:slide out:slide>

                                <CreateAccount/>

                            </section>

                        {/if}                         
                        
                    </section>
                    <p class='mb-3 text-center'>
                        Already have an account? 
                        <span
                            class='fw-bold'
                            on:click={() => context = "login"}
                            on:keypress={() => context = "login"}
                            role='button'
                            tabindex='0'
                        >
                            Sign in
                        </span>
                    </p>    
                </div>
            </div>
        </section>

    {/if}                                 

</div>
<style>       
    .login-logo {
        max-height: 20px;
        max-width: 20px;       
    }
    .card-login:hover {
        background: #E6E6E6;
    }
    .register-cover {
        z-index: 10;
    }
</style>